import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CheckboxValueDirective } from './mat-checkbox-value.directive';
import { EditMaskComponent } from './editmask.component';
import { DataWindowComponent } from './datawindow.component';
import { GroupBoxComponent } from './groupbox.component';
import { RadioButtonComponent } from './radiobutton.component';
import { StaticTextComponent } from './statictext.component';
import { CommandButtonComponent } from './commandbutton.component';
import { WindowComponent } from './window.component';
import { DataWindowDirective } from './datawindow.directive';
import { DataWindowControlComponent } from './datawindowcontrol.component';
import { ControlComponent } from './control.component';
import { DataStoreComponent } from './datastore.component';
import { DataWindowChildComponent } from './datawindowchild.component';
import { MenuComponent } from './menu.component';
import { RectangleComponent } from './rectangle.component';

@NgModule({
  declarations:[
    CheckboxValueDirective,
    DataWindowComponent,
    EditMaskComponent,
    GroupBoxComponent,
    RadioButtonComponent,
    StaticTextComponent,
    CommandButtonComponent,
    WindowComponent,
    DataWindowControlComponent,
    ControlComponent,
    DataStoreComponent,
    DataWindowChildComponent,
    DataWindowDirective,
    MenuComponent,
    RectangleComponent
  ],
  imports: [ 
    CommonModule,
 ],
 exports: [ 
    CommonModule, 
    CheckboxValueDirective,
    DataWindowComponent,
    EditMaskComponent,
    StaticTextComponent,
    CommandButtonComponent,
    WindowComponent,
    DataWindowControlComponent,
    ControlComponent,
    DataStoreComponent,
    DataWindowChildComponent,
    DataWindowDirective,
    MenuComponent,
    RectangleComponent
  ]
})
export class PowerbuilderSharedModule {

  constructor() {
  }
}